export interface DomainInfo {
  isProd: boolean;
  isAcceptance: boolean;
  domain: string;
}

export default (link?: string): DomainInfo => {
  const domainInfo = {
    isProd: false,
    isAcceptance: false,
    domain: 'guildeducation', // default to guildeducation for IE links to work in prod
  };

  const origin =
    link || window.location.origin || `${window.location.protocol}//${window.location.host}`;

  const isProd = origin.match(/(?:guildeducation)\.com/);
  const isAcceptance = origin.match(/(?:guildacceptance)\.com/);

  if (isProd) {
    domainInfo.isProd = true;
    domainInfo.domain = 'guildeducation';
  }
  if (isAcceptance) {
    domainInfo.isAcceptance = true;
    domainInfo.domain = 'guildacceptance';
  }

  return domainInfo;
};
